<div class="tooltipDialog-body" [ngClass]="{'showtime': showtime}" (clickOutside)="clickOutsideAction('leaveIt');">
    <span class="question">{{ 'freshRegistration.cancelBonus' | translate }}</span>
    <button class="przycisk green" (click)="action('leaveIt');">{{ 'freshRegistration.leaveIt' | translate }}</button>
    <button class="przycisk red" (click)="action('confirm');">{{ 'freshRegistration.confirm' | translate }}</button>
</div>
